import { render, staticRenderFns } from "./ResumenVentasMensual.vue?vue&type=template&id=0c6f0844&"
import script from "./ResumenVentasMensual.vue?vue&type=script&lang=js&"
export * from "./ResumenVentasMensual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports